import dispatcher from 'js/core/dispatcher';
import { getUserInfo_v1 } from 'js/library/utils/API/getUserInfo_v1.js';
import { store } from 'js/core/configureStore';

export const codeInputAction = (dispatch, cellPhone) => {
  const userInfo = {
    contactList: [
      {
        type: 'cellPhone',
        value:
          cellPhone !== undefined
            ? cellPhone
            : store.getState().phoneInputModel.cellPhone,
      },
    ],
  };

  return dispatcher(
    dispatch,
    'CODE_INPUT',
    getUserInfo_v1(['getUserInfo'], userInfo)
  );
};
